<template>
  <NuxtLayout name="shopping" shoppingSrc="/online-shopping/buy/">
    <!-- <
      sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
      width="1000"
      height="1000"
      format="webp"
      class="just-desktop w-full"
      quality="100"
      src="img/banner/fetr1403.png"
      alt=""
    />
    <NuxtImg
      sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
      width="1000"
      height="1000"
      format="webp"
      class="just-mobile w-full"
      quality="100"
      src="img/banner/fetr1403-mobile.png"
      alt=""
    /> -->

    <LazyHydrate when-idle>
      <div class="mb-6">
        <SectionShoppingElementHeaderWizard :steps="steps" :current-step="currentStep" />
        <div class="gridClass bg-blue-200 my-10 p-6 laptop:p-16 rounded">
          <template v-if="currentStep === 1">
            <SectionShoppingFirst
              shoppingType="callcenter"
              :refer="refer"
              @goToNextStep="currentStep = 2"
            />
          </template>
          <template v-if="currentStep === 2">
            <SectionShoppingThird
              shoppingType="callcenter"
              :numberType="numberType"
              @goToNextStep="currentStep = 3"
              @goToPrevStep="currentStep = 1"
            />
          </template>
          <template v-if="currentStep === 3">
            <SectionShoppingSecond
              shoppingType="callcenter"
              @goToNextStep="currentStep = 4"
              @goToPrevStep="currentStep = 2"
            />
          </template>
          <template v-if="currentStep === 4">
            <SectionShoppingForth
              @goToPrevStep="currentStep = 3"
              @goToStep2="currentStep = 2"
            />
          </template>
          <!-- <template v-if="currentStep === 5">
          <SectionShoppingFifth @goToSite="goToSite" />
        </template> -->
        </div>
      </div>
    </LazyHydrate>
  </NuxtLayout>
</template>

<script setup>
definePageMeta({
  layout: false,
});

useHead({
  link: [
    {
      rel: "canonical",
      href: "https://navatel.ir/online-shopping/buy/",
    },
  ],
});

const router = useRouter();
const route = useRoute();
const steps = {
  1: { title: "مشخصات مشتری", fullTitle: "مرحله اول: مشخصات مشتری " },
  2: { title: "انتخاب شماره", fullTitle: "مرحله دوم: انتخاب شماره " },
  3: { title: "انتخاب بسته", fullTitle: "مرحله سوم: انتخاب بسته " },
  4: { title: "صورتحساب و پرداخت", fullTitle: "مرحله چهارم: شرح صورتحساب " },
  5: { title: "تایید پرداخت", fullTitle: "مرحله پنجم: تایید پرداخت " },
};

const currentStep = ref(+route.query.step || 1);

const goToSite = () => {
  router.push("/");
};

const refer = ref(null);
const numberType = ref(null);

onMounted(() => {
  refer.value = window.history.state.back;
  console.log(refer.value);
  if (refer.value) {
    if (refer.value.startsWith("/rond")) {
      window.sessionStorage.setItem("numberType", "8280");
    } else if (!refer.value.startsWith("/online-shopping")) {
      window.sessionStorage.setItem("numberType", "");
    }
  }
  if (currentStep.value !== 1) {
    let token = useState("token").value;
    if (!token) {
      const shoppingData = JSON.parse(localStorage.getItem("callcenter"));
      if (shoppingData) {
        useState("user_type").value = shoppingData.user_type;
        useState("token").value = shoppingData.token;
        useState("InitialCredit").value = shoppingData.InitialCredit;
        useState("ChannelQuantity").value = shoppingData.ChannelQuantity;
        useState("didNo").value = shoppingData.didNo;
        useState("selectDidNoColor").value = shoppingData.selectDidNoColor;
        useState("selectDidNo").value = shoppingData.selectDidNo;
        useState("BundleId").value = shoppingData.BundleId;
        useState("FaxBundleId").value = shoppingData.FaxBundleId;
        useState("CloudVolumeId").value = shoppingData.CloudVolumeId;
        useState("IsCrm").value = shoppingData.IsCrm;
        useState("IsWebChat").value = shoppingData.IsWebChat;
        useState("SelectedCrmId").value = shoppingData.SelectedCrmId;
        useState("selectedNumberType").value = shoppingData.selectedNumberType;
      }
    }
  }
});

watch(
  () => currentStep.value,
  async (newVal) => {
    window.scrollTo({
      top: 0,
    });
    if (route.query.step != newVal) {
      router.push({
        path: "/online-shopping/buy/",
        query: { step: newVal },
      });
    }
  }
);

watch(
  () => route.query.step,
  async (newVal) => {
    if (currentStep.value != newVal) {
      currentStep.value = +newVal;
    }
  }
);
</script>
